import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  style: {"margin-top":"80px","padding-top":"20px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "text-muted mt-2" }

import { computed, onMounted, watch, shallowReactive, nextTick, ref, type Ref } from 'vue'
    import { useRoute } from 'vue-router'

    import PortfolioNavigation from '@common/Components/PortfolioNavigation.vue'
    import { MonthYear } from '@common/types'

    import { useAllProjectsPageQueryV1 } from '@Quest/Portfolios/queries-vue-composables'
    import { useSaveViewAllProjectsPageCommandV1 } from '@Quest/Portfolios/commands-vue-composables'

    import { useGridProjectByIdQueryV1 } from '@Quest/Projects/queries-vue-composables'

    import
        {
            useSetLifecycleCompletedCommandV1,
            useSetLifecycleInProgressCommandV1,
            useSetLifecyclePausedCommandV1,
            useSetLifecycleProposalCommandV1,
            useSetLifecycleQualifiedCommandV1,
            useSetLifecycleRejectedCommandV1,
            useSetLifecycleResumedCommandV1,
            useSetLifecycleScheduledCommandV1,
            useSetLifecycleTerminatedCommandV1
        } from '@Quest/Projects/commands-vue-composables'

    import { AllProjectsPageReadModel } from '@Quest/Portfolios/readmodels'
    import { GridProjectReadModel } from '@Quest/Projects/readmodels'

    import { ProjectsGridViewModel } from '@Quest/Projects/Components/ProjectsGrid'
    import ProjectsGrid from '@Quest/Projects/Components/ProjectsGrid.vue'

    import { ProjectProposalLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectProposalLifecycleSetter'
    import ProjectProposalLifecycleSetter from '@Quest/Projects/Components/ProjectProposalLifecycleSetter.vue'

    import { ProjectQualifiedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectQualifiedLifecycleSetter'
    import ProjectQualifiedLifecycleSetter from '@Quest/Projects/Components/ProjectQualifiedLifecycleSetter.vue'

    import { ProjectRejectedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectRejectedLifecycleSetter'
    import ProjectRejectedLifecycleSetter from '@Quest/Projects/Components/ProjectRejectedLifecycleSetter.vue'

    import { ProjectScheduledLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectScheduledLifecycleSetter'
    import ProjectScheduledLifecycleSetter from '@Quest/Projects/Components/ProjectScheduledLifecycleSetter.vue'

    import { ProjectInProgressLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectInProgressLifecycleSetter'
    import ProjectInProgressLifecycleSetter from '@Quest/Projects/Components/ProjectInProgressLifecycleSetter.vue'

    import { ProjectPausedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectPausedLifecycleSetter'
    import ProjectPausedLifecycleSetter from '@Quest/Projects/Components/ProjectPausedLifecycleSetter.vue'

    import { ProjectResumedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectResumedLifecycleSetter'
    import ProjectResumedLifecycleSetter from '@Quest/Projects/Components/ProjectResumedLifecycleSetter.vue'

    import { ProjectTerminatedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectTerminatedLifecycleSetter'
    import ProjectTerminatedLifecycleSetter from '@Quest/Projects/Components/ProjectTerminatedLifecycleSetter.vue'

    import { ProjectCompletedLifecycleSetterViewModel } from '@Quest/Projects/Components/ProjectCompletedLifecycleSetter'
    import ProjectCompletedLifecycleSetter from '@Quest/Projects/Components/ProjectCompletedLifecycleSetter.vue'



    // ======================
    // Route
    // ======================

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AllProjectsPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const tchProjectId = computed(() => Number(route.params.tchProjectId ?? 0))

    const {
        runAllProjectsPageQueryV1,
        modelAllProjectsPageQueryV1
    } = useAllProjectsPageQueryV1(workspaceId, tchProjectId)

    const rm = modelAllProjectsPageQueryV1 as Ref<AllProjectsPageReadModel | null>
    
    const portfolioId = computed(() => rm.value?.PortfolioId ?? '')
    const portfolioName = computed(() => rm.value?.PortfolioName ?? null)

    const lastProposalId = ref<string | null>(null)
    const lastQualifiedId = ref<string | null>(null)
    const lastRejectedId = ref<string | null>(null)
    const lastScheduledId = ref<string | null>(null)
    const lastInProgressId = ref<string | null>(null)
    const lastPausedId = ref<string | null>(null)
    const lastResumedId = ref<string | null>(null)
    const lastTerminatedId = ref<string | null>(null)
    const lastCompletedId = ref<string | null>(null)


    const {
        runGridProjectByIdQueryV1,
        modelGridProjectByIdQueryV1
    } = useGridProjectByIdQueryV1(workspaceId, portfolioId)



    // ======================
    // Commands
    // ======================

    const {
        invokeSaveViewAllProjectsPageCommandV1,
        succeedSaveViewAllProjectsPageCommandV1
    } = useSaveViewAllProjectsPageCommandV1(workspaceId, portfolioId)


    const {
        invokeSetLifecycleProposalCommandV1,
        succeedSetLifecycleProposalCommandV1
    } = useSetLifecycleProposalCommandV1(workspaceId, portfolioId, lastProposalId)

    const {
        invokeSetLifecycleQualifiedCommandV1,
        succeedSetLifecycleQualifiedCommandV1
    } = useSetLifecycleQualifiedCommandV1(workspaceId, portfolioId, lastQualifiedId)

    const {
        invokeSetLifecycleRejectedCommandV1,
        succeedSetLifecycleRejectedCommandV1
    } = useSetLifecycleRejectedCommandV1(workspaceId, portfolioId, lastRejectedId)

    const {
        invokeSetLifecycleScheduledCommandV1,
        succeedSetLifecycleScheduledCommandV1
    } = useSetLifecycleScheduledCommandV1(workspaceId, portfolioId, lastScheduledId)

    const {
        invokeSetLifecycleInProgressCommandV1,
        succeedSetLifecycleInProgressCommandV1
    } = useSetLifecycleInProgressCommandV1(workspaceId, portfolioId, lastInProgressId)

    const {
        invokeSetLifecyclePausedCommandV1,
        succeedSetLifecyclePausedCommandV1
    } = useSetLifecyclePausedCommandV1(workspaceId, portfolioId, lastPausedId)

    const {
        invokeSetLifecycleResumedCommandV1,
        succeedSetLifecycleResumedCommandV1
    } = useSetLifecycleResumedCommandV1(workspaceId, portfolioId, lastResumedId)

    const {
        invokeSetLifecycleTerminatedCommandV1,
        succeedSetLifecycleTerminatedCommandV1
    } = useSetLifecycleTerminatedCommandV1(workspaceId, portfolioId, lastTerminatedId)

    const {
        invokeSetLifecycleCompletedCommandV1,
        succeedSetLifecycleCompletedCommandV1
    } = useSetLifecycleCompletedCommandV1(workspaceId, portfolioId, lastCompletedId)



    // ======================
    // ViewModels
    // ======================

    const grid = shallowReactive(new ProjectsGridViewModel())

    const projectProposalLifecycleSetter = shallowReactive(new ProjectProposalLifecycleSetterViewModel())
    const projectQualifiedLifecycleSetter = shallowReactive(new ProjectQualifiedLifecycleSetterViewModel())
    const projectRejectedLifecycleSetter = shallowReactive(new ProjectRejectedLifecycleSetterViewModel())
    const projectScheduledLifecycleSetter = shallowReactive(new ProjectScheduledLifecycleSetterViewModel())
    const projectInProgressLifecycleSetter = shallowReactive(new ProjectInProgressLifecycleSetterViewModel())
    const projectPausedLifecycleSetter = shallowReactive(new ProjectPausedLifecycleSetterViewModel())
    const projectResumedLifecycleSetter = shallowReactive(new ProjectResumedLifecycleSetterViewModel())
    const projectTerminatedLifecycleSetter = shallowReactive(new ProjectTerminatedLifecycleSetterViewModel())
    const projectCompletedLifecycleSetter = shallowReactive(new ProjectCompletedLifecycleSetterViewModel())

    // ======================
    // Handlers
    // ======================

    function handleShowGridColumnsEditor()
    {
        grid.showGridColumnsEditor()
    }

    function handleSaveViewSettings()
    {
        invokeSaveViewAllProjectsPageCommandV1({
            Grid: grid.getJson()
        })
    }

    function handleClearGridFilters()
    {
        grid.clearFilters()
    }

    function handleExportGrid()
    {
        grid.exportGrid()
    }

    function handleProposed(projectId: string)
    {
        lastProposalId.value = projectId
        invokeSetLifecycleProposalCommandV1()
    }

    function handleQualified(projectId: string)
    {
        lastQualifiedId.value = projectId
        invokeSetLifecycleQualifiedCommandV1()
    }

    function handleRejected(projectId: string)
    {
        lastRejectedId.value = projectId
        invokeSetLifecycleRejectedCommandV1()
    }

    function handleScheduled(projectId: string, startDate: MonthYear)
    {
        lastScheduledId.value = projectId
        invokeSetLifecycleScheduledCommandV1({ StartDate: startDate })
    }

    function handleStarted(projectId: string, startDate: MonthYear)
    {
        lastInProgressId.value = projectId
        invokeSetLifecycleInProgressCommandV1({ StartDate: startDate })
    }

    function handlePaused(projectId: string)
    {
        lastPausedId.value = projectId
        invokeSetLifecyclePausedCommandV1()
    }

    function handleResumed(projectId: string)
    {
        lastResumedId.value = projectId
        invokeSetLifecycleResumedCommandV1()
    }

    function handleTerminated(projectId: string)
    {
        lastTerminatedId.value = projectId
        invokeSetLifecycleTerminatedCommandV1()
    }

    function handleCompleted(projectId: string)
    {
        lastCompletedId.value = projectId
        invokeSetLifecycleCompletedCommandV1()
    }

    // ======================
    // Query Watchers
    // ======================

    watch(rm, (current) =>
    {
        if (!current) return

        nextTick(() =>
        {
            grid.renderGrid(
                current.Grid.IdField,
                current.Grid.Fields,
                current.Grid.DefaultFieldIds,
                current.Grid.Options
            )

            grid.setProjects(current.Projects.map(p => p.Properties))
        })
    })

    watch(modelGridProjectByIdQueryV1 as Ref<GridProjectReadModel | null>, (current) =>
    {
        if (!current || !rm.value) return

        rm.value.Projects = rm.value.Projects.filter(p => p.Id !== current.Id)
        rm.value.Projects.push(current)

        grid.update(current.Properties)
    })



    // ======================
    // Command Watchers
    // ======================

    function refreshProject(projectId: string)
    {
        runGridProjectByIdQueryV1({ ProjectId: projectId })
    }

    watch(succeedSaveViewAllProjectsPageCommandV1, (c, p) =>
    {
        if (c && !p) alert('Saved')
    })

    watch(succeedSetLifecycleProposalCommandV1, (c, p) =>
    {
        if (c && !p && lastProposalId.value)
        {
            refreshProject(lastProposalId.value)
            projectProposalLifecycleSetter.close()
            lastProposalId.value = null
        }
    })

    watch(succeedSetLifecycleQualifiedCommandV1, (c, p) =>
    {
        if (c && !p && lastQualifiedId.value)
        {
            refreshProject(lastQualifiedId.value)
            projectQualifiedLifecycleSetter.close()
            lastQualifiedId.value = null
        }
    })

    watch(succeedSetLifecycleRejectedCommandV1, (c, p) =>
    {
        if (c && !p && lastRejectedId.value)
        {
            refreshProject(lastRejectedId.value)
            projectRejectedLifecycleSetter.close()
            lastRejectedId.value = null
        }
    })

    watch(succeedSetLifecycleScheduledCommandV1, (c, p) =>
    {
        if (c && !p && lastScheduledId.value)
        {
            refreshProject(lastScheduledId.value)
            projectScheduledLifecycleSetter.close()
            lastScheduledId.value = null
        }
    })

    watch(succeedSetLifecycleInProgressCommandV1, (c, p) =>
    {
        if (c && !p && lastInProgressId.value)
        {
            refreshProject(lastInProgressId.value)
            projectInProgressLifecycleSetter.close()
            lastInProgressId.value = null
        }
    })

    watch(succeedSetLifecyclePausedCommandV1, (c, p) =>
    {
        if (c && !p && lastPausedId.value)
        {
            refreshProject(lastPausedId.value)
            projectPausedLifecycleSetter.close()
            lastPausedId.value = null
        }
    })

    watch(succeedSetLifecycleResumedCommandV1, (c, p) =>
    {
        if (c && !p && lastResumedId.value)
        {
            refreshProject(lastResumedId.value)
            projectResumedLifecycleSetter.close()
            lastResumedId.value = null
        }
    })

    watch(succeedSetLifecycleTerminatedCommandV1, (c, p) =>
    {
        if (c && !p && lastTerminatedId.value)
        {
            refreshProject(lastTerminatedId.value)
            projectTerminatedLifecycleSetter.close()
            lastTerminatedId.value = null
        }
    })

    watch(succeedSetLifecycleCompletedCommandV1, (c, p) =>
    {
        if (c && !p && lastCompletedId.value)
        {
            refreshProject(lastCompletedId.value)
            projectCompletedLifecycleSetter.close()
            lastCompletedId.value = null
        }
    })



    // ======================
    // Lifecycle
    // ======================

    onMounted(() =>
    {
        document.title = "Portfolio All | TransparentChoice"
        runAllProjectsPageQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ProjectProposalLifecycleSetter, {
      viewModel: _unref(projectProposalLifecycleSetter),
      onConfirm: handleProposed
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectQualifiedLifecycleSetter, {
      viewModel: _unref(projectQualifiedLifecycleSetter),
      onConfirm: handleQualified
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectRejectedLifecycleSetter, {
      viewModel: _unref(projectRejectedLifecycleSetter),
      onConfirm: handleRejected
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectScheduledLifecycleSetter, {
      viewModel: _unref(projectScheduledLifecycleSetter),
      onConfirm: handleScheduled
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectInProgressLifecycleSetter, {
      viewModel: _unref(projectInProgressLifecycleSetter),
      onConfirm: handleStarted
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectPausedLifecycleSetter, {
      viewModel: _unref(projectPausedLifecycleSetter),
      onConfirm: handlePaused
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectResumedLifecycleSetter, {
      viewModel: _unref(projectResumedLifecycleSetter),
      onConfirm: handleResumed
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectTerminatedLifecycleSetter, {
      viewModel: _unref(projectTerminatedLifecycleSetter),
      onConfirm: handleTerminated
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(ProjectCompletedLifecycleSetter, {
      viewModel: _unref(projectCompletedLifecycleSetter),
      onConfirm: handleCompleted
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(PortfolioNavigation, {
      workspaceId: workspaceId.value,
      projectId: tchProjectId.value
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(portfolioName.value), 1 /* TEXT */),
          _cache[0] || (_cache[0] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "All projects", -1 /* CACHED */))
        ]),
        _createElementVNode("div", { class: "col-lg-6 text-right align-self-end" }, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-outline-secondary",
            style: {"padding":"0.7em 2em"},
            onClick: handleSaveViewSettings
          }, "Save")
        ])
      ]),
      _cache[4] || (_cache[4] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      _createElementVNode("div", { class: "toolbar" }, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createCommentVNode("<button type=\"button\" class=\"btn btn-outline-secondary\">Action ({{selectedIds.length}})</button>")
        ], -1 /* CACHED */)),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary mr-1",
            onClick: handleShowGridColumnsEditor
          }, "Edit columns"),
          _createElementVNode("div", { class: "btn-group mr-1" }, [
            _cache[1] || (_cache[1] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-outline-secondary dropdown-toggle",
              "data-toggle": "dropdown"
            }, " Actions ", -1 /* CACHED */)),
            _createElementVNode("div", { class: "dropdown-menu dropdown-menu-right" }, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: handleClearGridFilters
              }, "Clear Filters")
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: handleExportGrid,
            title: "Download to spreadsheet"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "fa fa-download fa-lg" }, null, -1 /* CACHED */)
          ]))])
        ])
      ]),
      _createVNode(ProjectsGrid, { viewModel: _unref(grid) }, null, 8 /* PROPS */, ["viewModel"])
    ])
  ]))
}
}

})